module.exports = __webpack_public_path__ + "static/roadmap2018-363963a0a3da0590f3da72594d3ad1ce.svg";